export default __webpack_public_path__ + "static/media/skolval-2023.2835e7ce.pdf";